import { Component, OnInit } from '@angular/core';
import { StoresService } from '../../shared/stores.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { ToastrService } from 'ngx-toastr';
import { Stores } from '../../shared/stores.model';

@Component({
  selector: 'app-store-list',
  templateUrl: './store-list.component.html',
  styleUrls: ['./store-list.component.css']
})
export class StoreListComponent implements OnInit {

  store: Stores[];
  constructor(
    private service:StoresService,
    private firestore:AngularFirestore,
    private toastr : ToastrService) { }

  ngOnInit() {
    this.service.getStores().subscribe(actionArray =>{
      this.store = actionArray.map(item => {
        const data = item.payload.doc.data() as Stores;
        const id = item.payload.doc.id;
        return { id, ...data };
      })
    });
  }


  onEdit(str:Stores){
    this.service.storeData = Object.assign({},str);
  }

  onDelete(id: string){
    if(confirm("Are you sure to delete this Stores?")){
      this.firestore.doc('stores/' +id).delete();
      this.toastr.warning('Deleted Successfuly','Stores');
    }
  }

}
